module.exports = __webpack_public_path__ + "assets/img/rong.a6ce1e54.png";